import { useEffect } from "react";
import { Navigate } from "react-router";

import { PennText } from "@/components/ui";
import { registerDestination } from "@penn/web-common";

// `/register` under AUTH_MODE=oidc. The route stays registered so bookmarks and
// old links do not 404, but the Configurator no longer hosts a sign-up form in
// this mode — accounts are created at the platform sign-up door. Hand off with a
// full navigation (different origin); with no door configured, /login is the
// only honest place to send the visitor.
export function PlatformRegisterRedirect() {
  const destination = registerDestination();
  const external = destination?.kind === "external" ? destination.url : null;

  useEffect(() => {
    if (external) window.location.assign(external);
  }, [external]);

  if (!external) return <Navigate to="/login" replace />;

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <PennText as="p" size="base" align="center" color="on-navy-secondary">
        Taking you to sign-up…
      </PennText>
    </div>
  );
}
